import React from 'react';
type MobileMockupProps = {
  children: JSX.Element;
};
function MobileMockup({ children }: MobileMockupProps) {
  return (
    <div className='relative mx-auto border-gray-600 dark:border-gray-600 bg-gray-600 border-[14px] rounded-[2.5rem] h-[600px] w-full max-w-full sm:w-[400px]'>
      <div className='h-[32px] w-[3px] bg-gray-600 dark:bg-gray-600 absolute -start-[17px] top-[72px] rounded-s-lg'></div>
      <div className='h-[46px] w-[3px] bg-gray-600 dark:bg-gray-600 absolute -start-[17px] top-[124px] rounded-s-lg'></div>
      <div className='h-[46px] w-[3px] bg-gray-600 dark:bg-gray-600 absolute -start-[17px] top-[178px] rounded-s-lg'></div>
      <div className='h-[64px] w-[3px] bg-gray-600 dark:bg-gray-600 absolute -end-[17px] top-[142px] rounded-e-lg'></div>
      <div className='absolute top-0 left-1/2 -translate-x-1/2 h-5 w-2/5 bg-gray-600 z-[100] rounded-b-xl flex justify-evenly items-center pb-1'>
        <div className='rounded-xl w-2/3 h-[12px] bg-slate-500'></div>
        <div className='rounded-full w-[12px] h-[12px] bg-slate-400 flex items-center justify-center'>
          <div className='rounded-full w-[9px] h-[9px] bg-black'></div>
        </div>
      </div>
      <div className='rounded-[2rem] overflow-hidden  w-full max-w-full sm:w-[372px] h-[572px] bg-white dark:bg-gray-600'>
        {children}
      </div>
    </div>
  );
}

export default MobileMockup;
